<template>
  <b-modal
    id="reject-offer-modal"
    v-model="isVisible"
    :title="$t('detailedComparisonModal.question')"
    :ok-title="$t('detailedComparisonModal.rejectOffer')"
    :cancel-title="$t('companyProfile.lvEt')"
    ok-variant="danger"
    header-class="border-bottom-0"
    footer-class="border-top-0"
    content-class="p-4"
    @ok="confirmRejectOffer"
  >
    <div class="reject-modal-content">
      <div class="mb-3">
        <label class="form-label font-weight-bold">
          <i class="fa fa-exclamation-circle text-danger mr-2"></i>
          {{ $t('detailedComparisonModal.rejectReason') }}
        </label>
        <textarea
          v-model="rejectReason"
          class="form-control"
          :placeholder="$t('detailedComparisonModal.writeReason')"
          rows="5"
        ></textarea>
      </div>

      <div 
        v-if="validationMessage"
        class="alert alert-danger d-flex align-items-center"
      >
        <i class="fa fa-exclamation-triangle mr-2"></i>
        {{ validationMessage }}
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "RejectOfferModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    offerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      rejectReason: "",
      validationMessage: ""
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        // Reset form when modal is opened
        this.rejectReason = "";
        this.validationMessage = "";
      }
    }
  },
  methods: {
    confirmRejectOffer(bvModalEvt) {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.validationMessage = "Zəhmət olmasa səbəb yazın!";
        bvModalEvt.preventDefault();
        return;
      }
      
      this.$emit('confirm-reject', this.offerId, this.rejectReason);
    }
  }
};
</script>

<style scoped>
.reject-modal-content {
  font-size: 0.95rem;
}

.form-label {
  color: #495057;
}

.alert {
  font-size: 0.9rem;
  padding: 0.5rem 0.75rem;
}
</style>